"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleFacilityDto = exports.BasicFacilityDto = exports.FindFacilitiesOptionsDto = exports.UpdateFacilityAmenitiesDto = exports.UpdateFacilitySportsDto = exports.UpdateFacilityOpeningTimesDto = exports.UpdateFacilityDetailsDto = exports.FacilityDto = exports.CreateFacilityDto = exports.OpeningTimeDto = exports.OptionalFacilityIdDto = void 0;
const organization_dto_1 = require("../organization/dto/organization.dto");
const general_dto_1 = require("./general.dto");
class OptionalFacilityIdDto extends organization_dto_1.OptionalOrganizationIdDto {
}
exports.OptionalFacilityIdDto = OptionalFacilityIdDto;
class OpeningTimeDto {
}
exports.OpeningTimeDto = OpeningTimeDto;
class CreateFacilityDto {
}
exports.CreateFacilityDto = CreateFacilityDto;
class FacilityDto {
}
exports.FacilityDto = FacilityDto;
class UpdateFacilityDetailsDto {
}
exports.UpdateFacilityDetailsDto = UpdateFacilityDetailsDto;
class UpdateFacilityOpeningTimesDto {
}
exports.UpdateFacilityOpeningTimesDto = UpdateFacilityOpeningTimesDto;
class UpdateFacilitySportsDto {
}
exports.UpdateFacilitySportsDto = UpdateFacilitySportsDto;
class UpdateFacilityAmenitiesDto {
}
exports.UpdateFacilityAmenitiesDto = UpdateFacilityAmenitiesDto;
class FindFacilitiesOptionsDto extends general_dto_1.PaginationQuery {
}
exports.FindFacilitiesOptionsDto = FindFacilitiesOptionsDto;
class BasicFacilityDto extends general_dto_1.IdAndNameDto {
}
exports.BasicFacilityDto = BasicFacilityDto;
class SimpleFacilityDto extends BasicFacilityDto {
}
exports.SimpleFacilityDto = SimpleFacilityDto;
//# sourceMappingURL=facilities.dto.js.map